<template>
  <v-container id="docForm">
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Create Sale</v-toolbar-title>
      
        <v-switch
          class="mt-6"
          color="orange darken-3"
          v-model="printing"
          :label="`Print Receipt`"
        ></v-switch>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="3">
            <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="record.CardCode"
              :items="customers"
              label="Customer"
              item-text="Name"
              item-value="id"
              @change="getCustomerBalance(record.CardCode)"
            >
              <template v-if="enableCreate" v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn
                    :loading="searchingProduct"
                    class="ma-2"
                    color="accent"
                    dark
                    small
                    elevation="0"
                    @click="customerModal()"
                  >
                    <v-icon left>mdi-plus</v-icon>Create A Customer
                  </v-btn>
                </v-row>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="3">
            <v-text-field
              autocomplete="off"
              type="text"
              v-model="ref2"
              outlined
              dense
              label="Customer Id No."
            ></v-text-field>
          </v-col>

          <v-col cols="3">
            <v-text-field
              autocomplete="off"
              type="text"
              v-model="DocNum"
              outlined
              dense
              filled
              readonly
              label="Order No"
            ></v-text-field>
          </v-col>

          <v-col cols="3">
            <span v-if="role != 3" style="font-weight: bold; font-size: 16px"
              >Date: {{ date }}</span
            >
            <DatePicker
              v-else
              @date="setDate"
              :myDate="date"
              :title="`Date`"
              ref="dateRef"
            ></DatePicker>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- end of card one -->

    <!-- card 2 -->
    <v-card class="mt-3">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              light
              dense
              :items-per-page="pageItems"
              :headers="smsRef == 'beautybee' ? priceHeaders : bpHeaders"
              :items="orderItems"
              item-key="LineNum"
              hide-default-footer
              disable-sort
            >
              <template v-slot:item.Name="{ item }">
                <!-- autocomplete -->
                <v-text-field
                  style="width: 350px"
                  class="orderInput"
                  single-line
                  dense
                  readonly
                  v-model="item.Name"
                ></v-text-field>
              </template>

              <template v-slot:item.ref1="{ item }">
                <v-text-field
                  v-show="IMEI == 'Y'"
                  class="orderInput"
                  single-line
                  outlined
                  dense
                  v-model="item.ref1"
                ></v-text-field>
              </template>

              <template v-slot:item.available="{ item }">
                <div style="margin-right: ">{{ item.available }}</div>
              </template>

              <template v-slot:item.available="{ item }">
                <v-text-field
                  single-line
                  outlined
                  dense
                  readonly
                  filled
                  v-model="item.available"
                ></v-text-field>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  @input="inputChanged(item)"
                  single-line
                  outlined
                  dense
                  v-model="item.Quantity"
                ></v-text-field>
              </template>

              <template v-slot:item.Commission="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  single-line
                  outlined
                  dense
                  v-model="item.Commission"
                ></v-text-field>
              </template>

              <template v-slot:item.DiscSum="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  @input="inputChanged(item)"
                  single-line
                  outlined
                  dense
                  v-model="item.DiscSum"
                ></v-text-field>
              </template>

              <template v-slot:item.Price="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  @input="inputChanged(item)"
                  single-line
                  outlined
                  dense
                  v-model="item.Price"
                ></v-text-field>
              </template>

              <template v-slot:item.TaxId="{ item }">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  single-line
                  v-model="item.TaxId"
                  :items="taxGroups"
                  label="Tax"
                  item-text="Name"
                  item-value="id"
                  @change="inputChanged(item)"
                ></v-autocomplete>
              </template>

              <template v-slot:item.o_p_l_n_s_id="{ item }">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  single-line
                  v-model="item.o_p_l_n_s_id"
                  :items="item.priceLists"
                  label="Price List"
                  item-text="pricelist.Name"
                  item-value="pricelist.id"
                  @change="oplnChange(item)"
                ></v-autocomplete>
              </template>

              <template v-slot:item.BuyingPrice="{ item }">
                <v-text-field
                  :filled="activeStore != 150"
                  outlined
                  :readonly="activeStore != 150"
                  dense
                  v-model="item.BuyingPrice"
                ></v-text-field>
              </template>

              <template v-slot:item.UomEntry="{ item }">
                <v-text-field
                  filled
                  outlined
                  readonly
                  dense
                  value="Unit(s)"
                  v-if="item.ManualStatus == 'Y'"
                ></v-text-field>

                <v-autocomplete
                  v-else
                  dense
                  autocomplete="off"
                  outlined
                  single-line
                  v-model="item.UomEntry"
                  :items="item.ugp1"
                  label="UOM"
                  item-text="uomentry.UomName"
                  item-value="uomentry.id"
                  @change="uomChange(item, item.ugp1)"
                ></v-autocomplete>
              </template>

              <template v-slot:item.DisplayTotal="{ item }">
                <v-text-field
                  class="orderInput"
                  single-line
                  outlined
                  dense
                  filled
                  readonly
                  v-model="item.DisplayTotal"
                ></v-text-field>
              </template>

              <template v-slot:item.Profit="{ item }">
                <span style="padding: 2px; font-bold">{{
                  item.Quantity * (item.Price - item.BuyingPrice)
                }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>

            <!-- <v-btn @click="addRow" small color="primary" class="mt-1">
              <v-icon left>mdi-plus</v-icon>Add Row
            </v-btn> -->

            <v-autocomplete
              style="width: 350px"
              autocomplete="off"
              v-model="select"
              :isloading="isLoading"
              :items="products"
              :search-input.sync="searchProducts"
              @change="setOrderItem(select)"
              :item-text="AccountsVersion == 'Y' ? 'full_name' : 'Name'"
              item-value="id"
              cache-items
              class="mt-2"
              flat
              hide-no-data
              hide-details
              label="Search Product"
              outlined
              dense
            >
            <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title> {{ smsRef == 'pharmacy' ? data.item.full_name : data.item.Name }}</v-list-item-title>
                  <v-list-item-subtitle :v-html="`Available Qty: ${data.item.AvailableQty}`">Available Qty: {{ data.item.AvailableQty }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <!-- outsourced row -->
        <v-row class="subtitle-2 text--primary" style="margin-top: -30px">
          <v-col cols="12">
            <v-btn text color="accent" class="float-right" @click="outModal">
              <v-icon>mdi-plus</v-icon>Add Outsourced Item
            </v-btn>
          </v-col>

          <v-col
            cols="12"
            style="margin-top: -30px"
            v-show="outArray.length > 0"
          >
            <span>Outsourced Items List</span>
            <v-data-table
              light
              dense
              :items-per-page="pageItems"
              :headers="outHeaders"
              :items="outArray"
              item-key="LineNum"
              hide-default-footer
              disable-sort
              :mobile-breakpoint="0"
              :calculate-widths="true"
            >
              <template v-slot:item.Quantity="{ item }">
                <span style="margin-right: 15px !important">{{
                  item.Quantity
                }}</span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span style="margin-right: 15px !important">{{
                  item.Price.toLocaleString()
                }}</span>
              </template>

              <template v-slot:item.DisplayTotal="{ item }">
                <span>{{ item.DisplayTotal.toLocaleString() }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteOutRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>
        <!-- end of outsourced row -->
      </v-card-text>
    </v-card>
    <!-- end -->

    <v-row class="mt-2">
      <v-col cols="6">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-btn
                  style="float: right; margin-top: -17px"
                  color="accent"
                  text
                  @click.native="paymentDialog = true"
                >
                  <v-icon left>mdi-plus</v-icon>Add Payment
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="mb-1">
              <v-col cols="12" style="margin-top: -36px">
                <v-data-table
                  light
                  :headers="paymentHeaders"
                  :items="payments"
                  hide-default-footer
                >
                  <template v-slot:item.account="{ item }">
                    <span style="font-size: 16px">{{ item.account }}</span>
                  </template>
                  <template v-slot:item.SumApplied="{ item }">
                    <span style="font-size: 16px">{{
                      parseFloat(item.SumApplied).toLocaleString()
                    }}</span>
                  </template>
                  <!-- action template -->
                  <template v-slot:item.action="{ item }">
                    <v-btn @click="deleteAccount(item)" color="red" icon>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <!-- end -->
                </v-data-table>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row class="mt-3">
              <v-col cols="6">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  v-model="record.driver"
                  :items="drivers"
                  label="Driver/Rider"
                  item-text="Name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" v-show="SoldBy == 'Y'">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  v-model="UserSign"
                  :items="users"
                  label="Sold By/ Sale Person"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="Delivery Location"
                  v-model="record.DeliveryLocation"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card>
          <v-card-text>
            <v-row
              dense
              class="mt-2 py-2 px-2 title text--primary"
              style="background: #d3d3d3"
            >
              <!-- <v-col cols="6">Total Bef Disc: {{ totalDisplayAmount }}</v-col> -->

              <v-col cols="6">
                <span>Bill: {{ totalAfterDiscDisplay }}.00</span>
              </v-col>

              <v-col cols="6">Paid: {{ mPaid }}.00</v-col>

              <v-col cols="6"
                >Bal:
                <span style="color: red">{{ displayMBalance }}.00</span></v-col
              >

              <v-col cols="6">
                Profit:
                {{ orderProfit }}.00
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-row class="title text--primary mt-2">
              <v-col cols="12"
                ><span style="font-size: 14px">Calculate Cash Change Below</span
                ><br
              /></v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  dense
                  label="Amount Given"
                  @input="changeAmount"
                  v-model="AmountGiven"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <span style="font-weight: bold"
                  >Change: {{ changeCash.toLocaleString() }}</span
                >
              </v-col>
            </v-row></v-card-text
          >
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12">
        <v-btn color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>

    <!-- Payment dialog -->
    <v-dialog v-model="paymentDialog" max-width="700px">
      <v-card>
        <v-toolbar dense color="accent" dark>
          <v-toolbar-title>Record Payment</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="paymentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  v-model="paymentItem.SumApplied"
                  label="Amount Paid"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-autocomplete
                  autocomplete="off"
                  hide-details
                  dense
                  outlined
                  v-model="paymentItem.o_a_c_t_s_id"
                  :items="accounts"
                  label="Account"
                  item-text="Name"
                  item-value="id"
                >
                  <template v-if="enableCreate" v-slot:no-data>
                    <v-row align="center" justify="center">
                      <v-btn
                        :loading="searchingProduct"
                        class="ma-2"
                        color="accent"
                        dark
                        small
                        elevation="0"
                        @click="openCreate()"
                      >
                        <v-icon left>mdi-plus</v-icon>Create Account
                      </v-btn>
                    </v-row>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="paymentItem.PaymentRemarks"
                  label="Remarks(optional). i.e Ref code"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  v-model="paymentItem.PaymentPhone"
                  label="Phone Number(optional)"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" @click="addPayment" :loading="loader">
                  <v-icon left>mdi-plus</v-icon>Add
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of payment modal-->

    <!-- Customer quick add dialog modal-->
    <v-dialog v-model="customerDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create A Customer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="customerDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <customer-editor
              :initial="customerItem"
              @data="saveCustomer"
            ></customer-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- Account quick add dialog -->
    <v-dialog v-model="accountDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="accountDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <account-editor
              :initial="accountItem"
              @data="saveAccount"
            ></account-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- Outsourced dialog -->
    <v-dialog v-model="outsourcedDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="accent" dark>
          <v-toolbar-title
            >Outsourced Product (sourced from another shop)</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="outsourcedDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="subtitle-2 text--primary">
            <v-row>
              <v-col cols="12" xs="12" md="12">
                <v-text-field
                  autocomplete="off"
                  type="text"
                  v-model="outItem.Name"
                  label="Item Name"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="5" xs="5" md="4">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  v-model="outItem.Quantity"
                  @input="qtyOutChanged(outItem)"
                  label="Qty"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="7" xs="7" md="4">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  v-model="outItem.BuyingPrice"
                  @input="qtyOutChanged(outItem)"
                  label="Buying Price"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="7" xs="7" md="4">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  v-model="outItem.Price"
                  @input="qtyOutChanged(outItem)"
                  label="Selling Price"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" xs="12"
                ><span style="font-size: 18px"
                  >Total Bill: {{ outItem.DisplayTotal }}</span
                ></v-col
              >

              <v-col cols="12" md="4" xs="12"
                ><span style="font-size: 18px"
                  >Total Profit: {{ outsourcedProfit }}</span
                ></v-col
              >

              <v-col cols="12">
                <v-btn color="accent" @click="addOutProduct" :loading="loader">
                  <v-icon left>mdi-plus</v-icon>Add To List
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of outsourced modal-->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { http } from "@/common/index";
import AccountEditor from "@/components/subscriber/accounts/_components/quick-editor.vue";
import CustomerEditor from "@/components/subscriber/customers/_components/quick-editor.vue";
// import customWalkinVue from "../editing/sales/_components/custom-walkin.vue";
export default {
  name: "PosPortal",
  components: {
    AccountEditor,
    CustomerEditor,
  },
  props: {
    docCreate: {
      type: Boolean,
    },
    loaderOff: {
      type: Boolean,
    },
    copyStatus: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    printing: true,
    customerDialog: false,
    outsourcedDialog: false,
    currentCustomerBalance: null,
    select: null,
    searchProducts: null,
    isLoading: false,
    outItem: {},
    accountItem: {},
    customerItem: {},
    accountDialog: false,
    enableCreate: true,
    searchingProduct: false,
    UserSign: null,
    enablePriceList: "N",
    showStockHint: true,
    ref2: null,
    IMEI: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    AmountGiven: null,
    multiplePayment: "Y",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentItem: {},
    paymentDialog: false,
    changeCash: 0,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    stores: [],
    users: [],
    outArray: [],
    drivers: [],
    date: new Date().toISOString().substr(0, 10),
    smsRef: "",
    clearDate: "",
    dateReadonly: "Y",
    AccountsVersion: "N",
    posHeaders: [
      { text: "Product", value: "Name" },
      // { text: "Buying Price", value: "bp" },
      { text: "Available", value: "available" },
      { text: "Qty To Sell", value: "Quantity" },
      // { text: "Ref No/ IMEI", value: "ref1" },
      { text: "Sales Unit", value: "UomEntry" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "Price" },
      // { text: "Tax", value: "TaxId" },
      // { text: "Discount", value: "DiscSum" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" },
    ],
    bpHeaders: [
      { text: "Product", value: "Name" },
      // { text: "Available", value: "available" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Sales Unit", value: "UomEntry" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      // { text: "Commission", value: "Commission" },
      { text: "Margin", value: "Profit" },
      { text: "Action", value: "action" },
    ],
    uomHeaders: [
      { text: "Product", value: "Name" },
      { text: "Available", value: "available" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Sales Unit", value: "UomEntry" },
      { text: "Selling Price", value: "Price" },
      { text: "Discount", value: "DiscSum" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" },
    ],
    priceHeaders: [
      { text: "Product", value: "Name" },
      // { text: "Buying Price", value: "bp" },
      { text: "Available", value: "available" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Price List", value: "o_p_l_n_s_id" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" },
    ],
    outHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Profit", value: "LineProfit" },
      { text: "Action", value: "action" },
    ],
    paymentHeaders: [
      { text: "Account", value: "account" },
      { text: "Amount", value: "SumApplied" },
      { text: "Remarks", value: "PaymentRemarks" },
      { text: "Phone No.", value: "PaymentPhone" },
      { text: "Action", value: "action" },
    ],
  }),
  computed: {
    userName() {
      return localStorage.getItem("userName");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    orderProfit() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount =
              item.Price * item.Quantity - item.BuyingPrice * item.Quantity;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mTotalPayments() {
      let total = 0;
      if (typeof this.payments != "undefined" && this.payments.length > 0) {
        return this.payments
          .map((item) => {
            const amount = parseFloat(item.SumApplied);
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mPaid() {
      return this.mTotalPayments.toLocaleString();
    },
    mBalance() {
      let bill = 0;
      let paid = 0;
      bill = this.totalAfterDisc;
      paid = this.mTotalPayments;
      const balance = bill - paid;
      return balance;
    },
    displayMBalance() {
      return this.mBalance.toLocaleString();
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const balance = this.totalAmount - parseFloat(sum) - parseFloat(disc);
      return balance;
    },
    totalAfterDisc() {
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const total = this.totalAmount + this.outTotalProfit - parseFloat(disc);
      return total;
    },
    totalAfterDiscDisplay() {
      return this.totalAfterDisc.toLocaleString();
    },
    displayBalance() {
      return this.balance.toLocaleString();
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
    outsourcedProfit() {
      let qty = 0;
      let buyingPrice = 0;
      let sellingPrice = 0;
      let profit = 0;

      if (this.outItem.Quantity) {
        qty = this.outItem.Quantity;
      }

      if (this.outItem.BuyingPrice) {
        buyingPrice = this.outItem.BuyingPrice;
      }

      if (this.outItem.Price) {
        sellingPrice = this.outItem.Price;
      }

      profit = qty * sellingPrice - qty * buyingPrice;

      return profit;
    },
    outTotalAmount() {
      let total = 0;
      if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
        return this.outArray
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    outTotalProfit() {
      let total = 0;
      if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
        return this.outArray
          .map((item) => {
            const amount = item.LineProfit;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  watch: {
    stores: {
      handler: "setDriver",
      immediate: true,
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    querySelections(searchText) {
      const self = this;
      const url = "/search-products";
      const data = {
        searchText: searchText,
      };
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDriver(val) {
      if (val) {
        const store_id = this.activeStore;
        const selectedStore = val.find((record) => {
          return record.id === parseInt(store_id);
        });
        if (selectedStore && selectedStore.driver != undefined) {
          this.record.driver = selectedStore.driver.id;
        }
      }
    },
    setNewDriver() {
      const stores = this.stores;
      const store_id = this.activeStore;
      const selectedStore = stores.find((record) => {
        return record.id === parseInt(store_id);
      });
      if (selectedStore.driver) {
        this.record.driver = selectedStore.driver.id;
      }
    },
    outModal() {
      this.outItem = {};
      this.outsourcedDialog = true;
    },
    customerModal() {
      this.customerDialog = true;
    },
    saveCustomer(data) {
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            self.customers = [...this.customers, customer];
            self.record.CardCode = customer.id;
            self.$refs.snackbar.show("Customer Added Successully", "green");
            self.customerDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("btnLoader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("btnLoader", false);
        });
    },
    changeAmount() {
      let amountPaid = 0;
      let bill = 0;
      bill = this.totalAfterDisc;
      amountPaid = parseFloat(this.AmountGiven);
      const changeValue = amountPaid - bill;
      this.changeCash = changeValue;
    },
    openCreate() {
      this.accountDialog = true;
    },
    qtyOutChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.outItem.LineTotal = LineTotal;
      this.outItem.DisplayTotal = DisplayTotal;
    },
    addOutProduct() {
      if (
        this.outItem.Name == undefined ||
        this.outItem.Quantity == undefined ||
        this.outItem.Price == undefined ||
        this.outItem.Price == undefined
      ) {
        this.$refs.snackbar.show("Please fill all the fields!", "red");
      } else {
        const self = this;
        const initArray = [];
        self.outItem.LineNum = new Date().getTime();
        self.outItem.Commission = this.outsourcedProfit;
        self.outItem.LineProfit = this.outsourcedProfit;
        const LineTotal =
          parseFloat(this.outItem.Quantity) * parseFloat(this.outItem.Price);
        self.outItem.LineTotal = LineTotal;
        initArray.push(self.outItem);
        self.outArray = [...self.outArray, ...initArray];
        this.outItem = {};
        this.outsourcedDialog = false;
      }
    },
    deleteOutRow(item) {
      const selectedRow = this.outArray.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.outArray.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.outArray.splice(pos, 1);
    },
    saveAccount(data) {
      const url = "/accounts";
      const self = this;
      this.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = [...this.accounts, res.ResponseData];
            self.paymentItem.o_a_c_t_s_id = res.ResponseData.id;
            self.$refs.snackbar.show("Account Added Successully", "green");
            self.$store.commit("btnLoader", false);
            self.accountDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    addPayment() {
      const accoutId = this.paymentItem.o_a_c_t_s_id;
      if (accoutId == undefined) {
        this.$refs.snackbar.show("Please select payment mode!", "red");
      } else {
        if (this.paymentItem.SumApplied == undefined) {
          this.$refs.snackbar.show("Please enter amount paid!", "red");
        } else {
          const item = this.paymentItem;
          const account = this.accounts.find((record) => {
            return record.id === accoutId;
          });
          // check if payment mode exist
          const data = {
            o_a_c_t_s_id: account.id,
            account: account.Name,
            SumApplied: item.SumApplied,
            PaymentRemarks: item.PaymentRemarks,
            PaymentPhone: item.PaymentPhone,
          };
          this.payments.push(data);
          this.paymentItem = {};
          this.paymentDialog = false;

          // end of check
        }
      }
    },
    deleteAccount(item) {
      const selectedRow = this.payments.find((record) => {
        return record.o_a_c_t_s_id === item.o_a_c_t_s_id;
      });
      const pos = this.payments.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.payments.splice(pos, 1);
    },
    printReceipt(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.ref2;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.deliveryCustomer;
      const deliveryPhone = data.deliveryPhone;
      const totalDelivery = data.totalDelivery;

      const outstandingBalance = this.currentCustomerBalance + this.balance;

      return http.post("https://posprinter.local/print", {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
        outstandingBalance,
      });
    },
    printCityReceipt(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.ref2;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.deliveryCustomer;
      const deliveryPhone = data.deliveryPhone;
      const totalDelivery = data.totalDelivery;
      const deliveryLocation = this.record.DeliveryLocation;
      const payments = this.payments;

      const outstandingBalance = this.currentCustomerBalance + this.balance;

      return http.post("https://posprinter.local/print", {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
        payments,
        deliveryLocation,
        outstandingBalance,
      });
    },
    printReceiptLocal(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.custRef;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.deliveryCustomer;
      const deliveryPhone = data.deliveryPhone;
      const totalDelivery = data.totalDelivery;
      const outstandingBalance = this.currentCustomerBalance + this.balance;

      return http.post("http://localhost/print", {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
        outstandingBalance,
      });
    },
    printWindowsReceipt(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.ref2;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress || "";
      const deliveryCustomer = data.deliveryCustomer || "";
      const deliveryPhone = data.deliveryPhone || "";
      const totalDelivery = data.totalDelivery || 0;
      const DocDate = data.dataocDate;
      const storeName = this.storeName;

      const outstandingBalance = this.currentCustomerBalance + this.balance;
      // some updates here

      return http.post(
        "http://localhost/stalispos-receipt/src/transactions/PrintPosReceipt.php",
        {
          p_products,
          total_cost,
          DiscSum,
          totalAfterDisc,
          total_payments,
          userName,
          customerName,
          customerBalance,
          receipt_no,
          ref2,
          seller,
          ChangeAmount,
          AmountGiven,
          deliveryAddress,
          deliveryCustomer,
          deliveryPhone,
          totalDelivery,
          outstandingBalance,
          storeName,
          DocDate,
        }
      );
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    inputChanged(data) {
      if (data.Quantity > data.available) {
        this.$refs.snackbar.show(
          `Your stock is low! current stock ${data.available}`,
          "red"
        );
      }

      let Price;
      let Quantity;
      let DiscSum;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      if (data.DiscSum) {
        DiscSum = parseFloat(data.DiscSum);
      } else {
        DiscSum = 0;
      }
      const TotalBefTax = Price * Quantity;
      // add tax
      const tax = this.taxGroups.find((record) => {
        return record.id === data.TaxId;
      });
      let taxAmount = 0;
      let taxRate = 0;
      if (tax) {
        taxRate = tax.Rate;
        taxAmount = (taxRate / 100) * TotalBefTax;
      }
      const TotalAfterTax = TotalBefTax + taxAmount;
      const LineTotal = Math.round(TotalAfterTax - DiscSum);
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find
      // update record
      currentItem.TaxRate = taxRate;
      currentItem.TaxAmount = taxAmount;
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
      // }
    },
    oplnChange(item) {
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      const qData = {
        product_id: item.o_i_t_m_s_id,
        SUoMEntry: item.UomEntry,
        o_p_l_n_s_id: item.o_p_l_n_s_id,
      };
      const url = "/price-calculation";
      const self = this;
      self.$store.dispatch("post", { url, data: qData }).then((res) => {
        currentItem.Price = res.ResponseData.FINALSALESPRICE;
        self.orderItems[pos] = currentItem;
        self.inputChanged(currentItem);
      });
    },
    uomChange(item, ugp1) {
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const ugp1Record = ugp1.find((record) => {
        return record.UomEntry === item.UomEntry;
      });

      currentItem.Price = ugp1Record.SellingPrice;
      this.orderItems[pos] = currentItem;
      this.inputChanged(currentItem);
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            // current item definition
            let currentItem = {};

            const qData = {
              product_id: product.id,
              SUoMEntry: product.SUoMEntry,
              o_p_l_n_s_id: product.itm4[0].o_p_l_n_s_id,
              store_id: store_id,
            };

            // set price list
            currentItem.priceLists = product.itm4;
            currentItem.o_p_l_n_s_id = product.itm4[0].o_p_l_n_s_id;
            currentItem.Quantity = 1;
            currentItem.ManualStatus = product.ugpentry.IsManual;
            currentItem.UomEntry = product.SUoMEntry;
            currentItem.ugp1 = product.ugpentry.ugp1;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            currentItem.PurchaseCurrency = null;
            currentItem.cnvRate = null;
            currentItem.BaseCurrencyTotal = null;
            currentItem.TaxId = null;
            currentItem.TaxRate = null;
            currentItem.ref1 = null;
            currentItem.TaxAmount = null;
            currentItem.BatchID = null;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            let initArray = [];

            // check if manual
            const url = "/price-calculation";
            self.$store.dispatch("post", { url, data: qData }).then((res) => {
              console.log(res, "price calc response");
              // assign available and buying price
              currentItem.bp = res.ResponseData.BuyingPrice;
              currentItem.BuyingPrice = res.ResponseData.BuyingPrice;
              currentItem.available = res.ResponseData.available;
              // end of bp assign
              if (product.ugpentry.IsManual == "Y") {
                // check if manual yes and assign
                currentItem.Price = res.ResponseData.FINALSALESPRICE;
                currentItem.currentPrice = res.ResponseData.FINALSALESPRICE;
                const total = 1 * parseFloat(res.ResponseData.FINALSALESPRICE);
                currentItem.LineTotal = total;
                currentItem.DisplayTotal = total.toLocaleString();

                initArray.push(currentItem);
                this.orderItems = [...this.orderItems, ...initArray];
                this.select = null;
                // end of manual yes
              }

              // start of manual No status
              if (product.ugpentry.IsManual == "N") {
                let ugp1Data = product.ugpentry.ugp1;
                const ugp1Record = ugp1Data.find((record) => {
                  return record.UomEntry === product.SUoMEntry;
                });
                currentItem.Price = ugp1Record.SellingPrice;
                currentItem.currentPrice = ugp1Record.SellingPrice;
                const total = 1 * ugp1Record.SellingPrice;
                currentItem.LineTotal = total;
                currentItem.DisplayTotal = total.toLocaleString();

                // push to array
                initArray.push(currentItem);
                this.orderItems = [...this.orderItems, ...initArray];
                this.select = null;
                // end of push
              }
              // end of manual No status
            });

            // get price api call
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    sendData() {
      if (this.date != null) {
        if (this.SoldBy == "Y" && this.UserSign == null) {
          this.$refs.snackbar.show("Please select the seller", "red");
        } else {
          if (this.orderItems.length > 0 || this.outArray.length > 0) {
            let balance = 0;
            balance = this.mBalance;

            if (balance < 0) {
              this.$refs.snackbar.show(
                "Payments more than sale value not allowed!",
                "red"
              );
            } else {
              if (balance > 0 && this.record.CardCode == undefined) {
                this.$refs.snackbar.show("Please select customer", "red");
              } else {
                // get seller
                const sellerId = this.UserSign;
                let seller = {};
                if (sellerId !== null) {
                  seller = this.users.find((record) => {
                    return record.id === sellerId;
                  });
                }
                // end of get
                let saleDate = this.date;
                this.record = { ...this.record, DocDate: saleDate };
                const data = this.record;
                data.rows = this.orderItems;
                data.outRows = this.outArray;
                data.TargetType = null;
                data.BaseType = null;
                data.BaseEntry = null;
                data.ObjType = 14;
                data.DocTotal = this.totalAmount;
                data.DocNum = this.DocNum;
                data.UserSign = this.UserSign;
                data.ref2 = this.ref2;
                data.seller = seller.name;
                let Dis = 0;
                if (this.DiscOnTotal == null) {
                  Dis = 0;
                } else {
                  Dis = this.DiscOnTotal;
                }
                data.DiscSum = Dis;
                data.totalAfterDisc = this.totalAfterDisc;
                if (this.multiplePayment == "N") {
                  data.TotalPaid = this.SumApplied;
                  data.Balance = this.balance;
                } else {
                  data.TotalPaid = this.mTotalPayments;
                  data.Balance = this.mBalance;
                }

                let saleType = "";
                if (data.Balance > 0) {
                  saleType = "credit";
                } else {
                  saleType = "cash";
                }
                data.saleType = saleType;
                data.userName = this.userName;
                // set payments
                const paidAmount = this.SumApplied;
                if (this.multiplePayment == "N") {
                  let paymentData = { o_a_c_t_s_id: 1, SumApplied: paidAmount };
                  this.payments.push(paymentData);
                }
                data.payments = this.payments;

                // get customer details
                let CardCode = this.record.CardCode;
                const selectedCustomer = this.customers.find((record) => {
                  return record.id === CardCode;
                });

                let custName = "";
                let custPhone = "";
                let custAddress = "";

                if (selectedCustomer) {
                  custName = selectedCustomer.Name;
                  custPhone = selectedCustomer.PhoneNumber;
                  custAddress = selectedCustomer.Address;
                }

                data.deliveryCustomer = custName;
                data.deliveryPhone = custPhone;
                data.deliveryAddress = custAddress;

                // compute delivery charges
                const deliveryItems = this.orderItems.filter((record) => {
                  return record.itemType == "C";
                });

                let totalDelivery = 0;
                if (
                  typeof deliveryItems != "undefined" &&
                  deliveryItems.length > 0
                ) {
                  totalDelivery = deliveryItems
                    .map((item) => {
                      const amount = parseFloat(item.LineTotal);
                      totalDelivery = +amount;
                      return totalDelivery;
                    })
                    .reduce((val, a) => {
                      return val + a;
                    });
                }

                data.totalDelivery = totalDelivery;
                // end

                // // end
                const printData = data;
                // end
                // save data
                const url = "/documents";
                const self = this;
                this.loader = true;
                this.$store
                  .dispatch("post", { url, data })
                  .then((res) => {
                    if (res.ResultCode == 1200) {
                      if (self.printing == true) {
                        if (self.smsRef == "citysteel") {
                          self.printCityReceipt(printData);
                        } else {
                          self.printReceipt(printData);
                          self.printReceiptLocal(printData);
                          self.printWindowsReceipt(printData);
                        }
                      }

                      //self.printReceipt(printData);
                      self.getDocNum();
                      const NewDate = this.record.DocDate;
                      self.record = {};
                      self.record.DocDate = NewDate;
                      if (self.clearDate == "Y") {
                        this.$refs.dateRef.clearDate();
                      }
                      self.orderItems = [];
                      self.outArray = [];
                      self.SumApplied = 0;
                      self.payments = [];
                      self.DiscOnTotal = 0;
                      self.ref2 = null;
                      self.UserSign = null;
                      this.$refs.snackbar.show("Sale successful", "green");
                      self.loader = false;
                      self.setNewDriver();
                      self.getProducts();
                    } else {
                      self.loader = false;
                      this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                  })
                  .catch((err) => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                  });
              }
              // balance < 0 curly brace
            }
          } else {
            this.$refs.snackbar.show(
              "You must have at least one product",
              "red"
            );
          }
        }
      } else {
        this.$refs.snackbar.show("Please select date!", "red");
      }
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customers = res.ResponseData;
            customers.shift();
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      const id = this.activeStore;
      this.$store
        .dispatch("get", `/stores/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData.itm2;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.storeId = res.ResponseData.DefaultStockStore;
              self.IMEI = res.ResponseData.IMEI;
              self.SoldBy = res.ResponseData.SoldBy;
              self.smsRef = res.ResponseData.smsRef;
              self.enablePriceList = res.ResponseData.enablePriceList;
              self.clearDate = res.ResponseData.clearDate;
              self.AccountsVersion = res.ResponseData.AccountsVersion;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      let initArray = [];
      const LineNum = new Date().getTime();
      const details = {
        LineNum: LineNum,
        Name: null,
        Quantity: 1,
        Price: null,
        LineTotal: 0,
        TaxId: this.taxGroups[0].id,
        TaxRate: null,
        ref1: null,
        TaxAmount: null,
        UomEntry: null,
        ManualStatus: null,
        ugp1: [],
        DiscSum: null,
        DisplayTotal: 0,
        BatchID: null,
        PurchaseCurrency: null,
        cnvRate: null,
        BaseCurrencyTotal: null,
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    setDefaultRow() {
      const self = this;
      this.$store.dispatch("get", `/taxgroups/O`).then((res) => {
        if (res.ResultCode == 1200) {
          self.taxGroups = res.ResponseData;
          const LineNum = new Date().getTime();
          let initArray = [];
          const details = {
            LineNum: LineNum,
            Name: null,
            Quantity: 1,
            Price: null,
            LineTotal: 0,
            TaxId: res.ResponseData[0].id,
            TaxRate: null,
            ref1: null,
            TaxAmount: null,
            UomEntry: null,
            ManualStatus: null,
            ugp1: [],
            DiscSum: null,
            DisplayTotal: 0,
            BatchID: null,
            PurchaseCurrency: null,
            cnvRate: null,
            BaseCurrencyTotal: null,
          };
          initArray.push(details);
          this.orderItems = [...this.orderItems, ...initArray];
        }
      });
    },
    getDrivers() {
      const self = this;
      this.$store
        .dispatch("get", `/drivers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.drivers = res.ResponseData;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomerBalance(id) {
      const self = this;
      this.$store
        .dispatch("get", `/get-customer-balance/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.currentCustomerBalance = res.ResponseData.Balance;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    // this.setDefaultRow();
    Promise.all([
      this.getCustomers(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum(),
      this.getAccounts(),
      this.getUsers(),
      this.getDrivers(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>